import AgGridColumnConfig from "./AgGridColumnConfig";
import Alerts from "./Alerts";
import Announcement from "./Announcement";
import AsyncCategories from "./CategoriesAsync";
import Auth from "./Auth";
import AutomaticModeAsync from "./AutomaticModeAsync";
import Categories from "./Categories";
import ColumnConfig from "./ColumnConfig";
import CustomFormat from "./CustomFormat";
import CsvUpload from "./CsvUpload";
import Customer from "./Customer";
import DocumentEditor from "./DocumentEditor";
import DocumentPages from "./DocumentPages";
import DownloadInvoiceOptions from "./DownloadInvoiceOptions";
import DownloadOptions from "./DownloadOptions";
import ExternalFilter from "./ExternalFilter";
import FeatureGate from "./FeatureGate";
import Files from "./Files";
import FixBankPageAsync from "./FixBankPageAsync";
import GenericOptions from "./GenericOption";
import HelpDrawer from "./HelpDrawer";
import Integration from "./Integration";
import InvoiceApprovalStatus from "./InvoiceApprovalStatus";
import InvoiceManager from "./InvoiceManager";
import Job from "./Job";
import JobData from "./JobData";
import JobDocument from "./JobDocument";
import JobExport from "./JobExport";
import JobRatings from "./JobRatings";
import Jobs from "./Jobs";
import JobTags from "./JobTags";
import MatchedTransactions from "./MatchedTransactions";
import ModalManager from "./ModalManager";
import OnboardingSteps from "./OnboardingSteps";
import PayeeCleanupAsync from "./PayeeCleanupAsync";
import Plans from "./Plans";
import Promotions from "./Promotions";
import QboAccount from "./QboAccount";
import QboAccountCategory from "./QboAccountCategory";
import QboCustomer from "./QboCustomer";
import QboItem from "./QboItem";
import QboTaxCode from "./QboTaxCode";
import QboVendor from "./QboVendor";
import Reconciler from "./Reconciler";
import XeroAccount from "./XeroAccount";
import XeroContact from "./XeroContact";
import XeroItem from "./XeroItem";
import XeroTaxRate from "./XeroTaxRate";
import Referrals from "./Referrals";
import SetupChecklistDrawer from "./SetupChecklistDrawer";
import Sidebar from "./Sidebar";
import StripeCustomer from "./StripeCustomer";
import Subscription from "./Subscription";
import SupportTool from "./SupportTool";
import Survey from "./Survey";
import TagLevel from "./TagLevel";
import TagLevelIntegration from "./TagLevelIntegration";
import TagRegexes from "./TagRegexes";
import TagRegexesInvoice from "./TagRegexesInvoice";
import TagRegexesTransaction from "./TagRegexesTransaction";
import Template from "./Template";
import TemplateField from "./TemplateField";
import TemplateFieldsProgress from "./TemplateFieldsProgress";
import TemplateMetadataFields from "./TemplateMetadataFields";
import Tours from "./Tours";
import TransactionManager from "./TransactionManager";
import TrialLimitation from "./TrialLimitation";
import UpgradePlan from "./UpgradePlan";
import User from "./User";
import UserOfInterest from "./UserOfInterest";
import UserRecentTemplate from "./UserRecentTemplate";
import View from "./View";
import RecentNavigation from "./RecentNavigation";

const reducers = {
  AgGridColumnConfig,
  Alerts,
  Announcement,
  AsyncCategories,
  Auth,
  AutomaticModeAsync,
  Categories,
  ColumnConfig,
  CustomFormat,
  CsvUpload,
  Customer,
  DocumentEditor,
  DocumentPages,
  DownloadInvoiceOptions,
  DownloadOptions,
  ExternalFilter,
  FeatureGate,
  Files,
  FixBankPageAsync,
  GenericOptions,
  HelpDrawer,
  Integration,
  InvoiceApprovalStatus,
  InvoiceManager,
  Job,
  JobData,
  JobDocument,
  JobExport,
  JobRatings,
  Jobs,
  JobTags,
  MatchedTransactions,
  ModalManager,
  OnboardingSteps,
  PayeeCleanupAsync,
  Plans,
  Promotions,
  QboAccount,
  QboAccountCategory,
  QboCustomer,
  QboItem,
  QboTaxCode,
  QboVendor,
  Reconciler,
  Referrals,
  RecentNavigation,
  SetupChecklistDrawer,
  Sidebar,
  StripeCustomer,
  Subscription,
  SupportTool,
  Survey,
  TagLevel,
  TagLevelIntegration,
  TagRegexes,
  TagRegexesInvoice,
  TagRegexesTransaction,
  Template,
  TemplateField,
  TemplateFieldsProgress,
  TemplateMetadataFields,
  Tours,
  TransactionManager,
  TrialLimitation,
  UpgradePlan,
  User,
  UserOfInterest,
  UserRecentTemplate,
  View,
  XeroAccount,
  XeroContact,
  XeroItem,
  XeroTaxRate
};

export default reducers;
